<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs12 mb-3>
          <h1 class="max">{{i18n('Operações de Câmbio')}}</h1>
        </v-flex>
        <v-flex xs12>
          <div v-if="exchangesLoaded == 'not_loaded'">{{i18n('Carregando operações...')}}</div>
          <div v-if="exchangesLoaded == 'error'">{{i18n('Algo errado. Não foi possível carregar as operações.')}}</div>
          <div v-if="exchangesLoaded == 'not_authorized'">{{i18n('Não foi possível carregar as operações. Você não foi autorizado.')}}</div>
          <div v-if="exchangesLoaded == 'empty'">{{i18n('Não existem operações de câmbio neste momento.')}}</div>
          <transition name="fade">
            <exchange-list :is_admin="false" class="mt-3" :config="exchangesConfig" v-if="exchangesLoaded == 'ok'" @onExchangeRemoved="onExchangeRemoved" @loadMoreRecords="loadExchanges"/>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import LeftBarLayout from "./layouts/LeftBarLayout"
import ExchangeList from "./ExchangeList"

export default {
  name: 'AdminExchangeList',
  components: { layout: LeftBarLayout, 'exchange-list': ExchangeList },
  data() {
    return {
      exchangesConfig: {
        title: 'Fechamentos de câmbio recentes',
        records: [],
        loading: false
      },
      exchangesLoaded: 'not_loaded',
    }
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()

    this.loadExchanges(null)
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    onExchangeRemoved() {
      if (this.exchangesConfig.records.length == 0) {
        this.exchangesLoaded = 'empty'
      }
    },
    loadExchanges(last_id) {
      let successCallback = (response) => {
        this.exchangesConfig.loading = false

        if (response.body.data) {
          this.exchangesConfig.records = this.exchangesConfig.records.concat(...response.body.data)
          if (this.exchangesConfig.records.length === 0) {
            this.exchangesLoaded = 'empty'
          } else {
            this.exchangesLoaded = 'ok'
          }
        } else {
          this.exchangesLoaded = 'error'
        }
      }

      let errorCallback = (response) => {
        this.exchangesConfig.loading = false

        if (response.status === 401) {
          this.exchangesLoaded = 'not_authorized'
        } else {
          this.exchangesLoaded = 'error'
        }
      }

      this.exchangesConfig.loading = true
      let token = this.$cookies.get('api_token')
      this.$http.get(this.$root.urls.customer__exchanges, { params: { last_id: last_id }, headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/ClientExchangeList.vue